module.exports = __webpack_public_path__ + "static/media/treasure_red.ca82a676.svg";